// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useMeetTheFounderOptions = () => {
  const { options } = useStaticQuery(graphql`
    query MeetTheFounderOptions {
      options: wp(global: {}) {
        global {
          meetTheFounder {
            heading: meetTheFounderHeading
            text: meetTheFounderText
            buttons: meetTheFounderButtons {
              button {
                target
                title
                url
              }
            }
            image: meetTheFounderImage {
              gatsbyImage(width: 1000)
              altText
              mediaDisplayOptions {
                filter
              }
            }
          }
        }
      }
    }
  `);

  return options?.global?.meetTheFounder;
};

export default useMeetTheFounderOptions;
